package com.starparty.app.astro0.js

import com.starparty.app.astro0.SP_Time
import kotlin.js.Date

class SP_JSTime(year: Int,
    month: Int,
    dayOfMonth: Int,
    hour: Int,
    minute: Int,
    second: Int,
    millisecond: Int):
SP_Time(year, month, dayOfMonth, hour, minute, second, millisecond) {

    override fun incrementByMilliseconds(milliseconds: Double): SP_Time {

        val ms = millisecond + milliseconds

        val cal = Date(yearUTC(), monthUTC(), dayOfMonthUTC(), hourOfDayUTC(), minuteUTC(), secondUTC(), ms.toInt())

        val newYear = cal.getUTCFullYear()
        val newMonth = cal.getUTCMonth() // check if zero indexed Jan=0
        val newDay = cal.getUTCDay()
        val newHour = cal.getUTCHours()
        val newMin = cal.getUTCMinutes()
        val newSec = cal.getUTCSeconds()
        val newMS = cal.getUTCMilliseconds()

        return SP_JSTime(newYear, newMonth, newDay, newHour, newMin, newSec, newMS)
    }

}